<template>
  <v-app-bar
    :class="{ collapsed }"
    class="header"
    app
    :height="['lg', 'xl'].includes($size) ? 100 : 60"
    color="white"
    :elevation="0"
    fixed
  >
    <router-link to="/" class="header-start">
      <div class="header-logo"></div>
      <div class="header__separator"></div>
      <div class="header-logo-append"></div>
    </router-link>
    <HeaderNav />
    <div class="header-end">
      <v-btn @click="$emit('input', !value)" icon class="sidebar-drawer">
        <v-icon color="white">
          {{ value ? "$close" : "$menu" }}
        </v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import HeaderNav from "./Header/HeaderNav";

export default {
  components: { HeaderNav },
  props: {
    collapsed: Boolean,
    value: Boolean,
  },
  computed: {
    rootUrl() {
      return `/${this.activePage?.slug || ""}`;
    },
  },
};
</script>

<style scoped lang="scss">
.header::v-deep {
  .v-toolbar__content {
    background: #003a70;
    justify-content: space-between;
    padding: 0;
  }
}

.header {
  transition: 0.3s;

  &::v-deep .v-toolbar__content {
    transition: 0.3s;
  }
}

.header.collapsed {
  height: 60px !important;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15) !important;

  &::v-deep .v-toolbar__content {
    height: 60px !important;
  }

  .header__separator {
    height: 32px;
    margin: 0 10px;
  }

  .header-logo {
    width: 117px;
    height: 50px;

    &-append {
      height: 46px;
      width: 115px;
    }
  }

  .header-start,
  .header-end {
    padding: 10px;
  }
}

.header-start,
.header-end {
  display: flex;
  align-items: center;
  padding: 20px;
}

.header-end {
}

.header-logo {
  display: block;
  width: 117px;
  height: 50px;
  background-image: url("~@/assets/logo.png");
  background-size: contain;
  background-position: center center;
  transition: 0.3s;

  &-append {
    background-image: url("~@/assets/logo-append.svg");
    background-position: center center;
    background-size: contain;
    width: 135px;
    height: 45px;
  }
}

.header {
  &__separator {
    width: 1px;
    height: 50px;
    background: #b1b3b3;
    margin: 0 20px;
  }
}

.sidebar-drawer {
  display: none;
}

@media screen and (max-width: 1264px) {
  .header {
    &,
    &::v-deep .v-toolbar__content {
      height: 60px !important;
    }

    &-logo {
      width: 117px;
      height: 50px;
    }

    &-title {
      margin: 0;
    }

    &-title {
      &__separator {
        height: 30px;
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .sidebar-drawer {
    display: block !important;
  }

  .header-start {
    justify-content: space-between;
  }

  .header__separator,
  .header.collapsed .header__separator {
    height: 32px;
    margin: 0 10px;
  }

  .header-logo,
  .header.collapsed .header-logo {
    height: 50px;
    width: 84px;

    &-append {
      width: 90px;
      height: 46px;
    }
  }

  .header-start,
  .header-end {
    padding: 10px;
  }

  .header-end {
    padding-right: 10px !important;
  }

  .header.collapsed .header-logo-append {
    width: 90px;
    height: 46px;
  }
}
</style>
